export const collaborationRoles = ["member", "admin"];
export const organisationRoles = ["manager", "admin"];
export const serviceRoles = ["manager", "admin"];
